import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CorporateDashboardComponent } from "./corporate-dashboard/corporate-dashboard.component";
import { CorporateLedgerComponent } from "./corporate-ledger/corporate-ledger.component";
import { CorporateProfileComponent } from "./corporate-profile/corporate-profile.component";
import { CorporateTripsComponent } from "./corporate-trips/corporate-trips.component";
import { CorporateTruckDetailsComponent } from "./corporate-truck-details/corporate-truck-details.component";
import { CorporateWorkOrdersComponent } from "./corporate-work-orders/corporate-work-orders.component";

const routes: Routes = [
  {
    path: "corporate",
    children: [
      {
        path: "create-work-order",
        component: CorporateTruckDetailsComponent,
      },
      {
        path: "dashboard",
        component: CorporateDashboardComponent,
      },
      {
        path: "trips",
        component: CorporateTripsComponent,
      },
      {
        path: "work-order-list",
        component: CorporateWorkOrdersComponent,
      },
      {
        path: "ledger",
        component: CorporateLedgerComponent,
      },
      {
        path: "profile",
        component: CorporateProfileComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CorporateRoutingModule {}
